module.exports = __webpack_public_path__ + "img/ricelog_pinicon_012.e3ac516b.png";